import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";
import User from "../../models/user.ts";

export default class V1UserGot extends BaseIncomingPayload {
  public readonly payload: V1UserGotPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_USER_GOT);

    this.payload = new V1UserGotPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1UserGotPayload {
  public readonly user: User;

  constructor(payload: Record<string, unknown>) {
    this.user = User.fromPayload(ParseUtils.parseObject(payload, "user"));
  }
}
